import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MessageCircle } from "lucide-react";
import { KnovasMark } from "./KnovasLogo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#2B2B2B] text-white mt-32">
      <div className="h-1 w-full bg-[#FF6A00]" aria-hidden />
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-baseline mb-6">
            <span className="text-3xl font-black uppercase tracking-[0.04em]" style={{ fontFamily: "'Anton', sans-serif" }}>
              <span style={{ color: "#FF6A00" }}>K</span>
              <span className="text-white">NOVAS</span>
            </span>
          </div>
          <p className="text-sm leading-relaxed text-white/70 max-w-md">
            Built strong. Built to last. KNOVAS engineers premium hardware for kitchens, wardrobes and modern interiors —
            crafted for installers who refuse to compromise.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-white/50 mb-4">Catalogue</h4>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-link-catalogue" to="/catalogue" className="hover:text-[#FF6A00]">All Series</Link></li>
            <li><Link data-testid="footer-link-hinges" to="/series/hinges" className="hover:text-[#FF6A00]">Hinges</Link></li>
            <li><Link data-testid="footer-link-slides" to="/series/slides" className="hover:text-[#FF6A00]">Slides</Link></li>
            <li><Link data-testid="footer-link-nsb" to="/series/nsb-slim-box" className="hover:text-[#FF6A00]">NSB Slim Box</Link></li>
            <li><Link data-testid="footer-link-about" to="/about" className="hover:text-[#FF6A00]">About</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-[#FF6A00]">Contact / Dealer Enquiry</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-white/50 mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <MessageCircle size={14} className="text-[#FF6A00]" />
              <a href="https://wa.me/917259886651" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="hover:text-[#FF6A00]">+91 72598 86651</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={14} className="text-[#FF6A00]" />
              <a href="mailto:knovastrading@gmail.com" data-testid="footer-email" className="hover:text-[#FF6A00]">knovastrading@gmail.com</a>
            </li>
            <li className="flex items-center gap-3">
              <Instagram size={14} className="text-[#FF6A00]" />
              <a href="https://instagram.com/knovas_trading" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="hover:text-[#FF6A00]">@knovas_trading</a>
            </li>
            <li className="flex items-center gap-3">
              <Facebook size={14} className="text-[#FF6A00]" />
              <a href="https://www.facebook.com/share/1F9H6JGAZC/" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="hover:text-[#FF6A00]">Facebook</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40 tracking-widest uppercase">© {new Date().getFullYear()} KNOVAS Trading. All Rights Reserved.</p>
          <p className="text-xs text-white/40 tracking-[0.3em] uppercase">Built Strong. Built To Last.</p>
        </div>
      </div>
    </footer>
  );
}
